import { WithStyles } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';
import Popover from '@material-ui/core/Popover';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import StarRate from '@material-ui/icons/StarRate';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import { isMobile } from '../utils/MobileCheck';
import GridDivRow from './GridDivRow';

const StyledGridRow = withStyles((theme: Theme) =>
	createStyles({
		base: {
			borderLeft: `1px solid ${grey[400]}`,
		},
		root: {
			'&:nth-last-of-type(1)': {
				backgroundColor: `${red[50]} !important`,
			},
			'&:nth-of-type(even)': {
				backgroundColor: blue[50],
			},
		},
	})
)(GridDivRow);

const styles = (theme: Theme) =>
	createStyles({
		contentArea: {
			display: 'flex',
			flexDirection: 'column',
		},
		contentArea1: {
			display: 'flex',
			flexDirection: 'column',
		},
		contentArea11: {
			padding: '8px 8px',
		},
		contentArea2: {
			display: 'flex',
			flexDirection: 'column',
			position: 'relative',
		},
		contentArea3: {
			display: 'flex',
			flexDirection: 'column',
			padding: '10px',
		},
		contentArea31: {
			padding: '11px 10px',
		},
		contentArea32: {
			border: '2px solid #ccc',
			borderRadius: '10px',
			marginLeft: '30px',
			padding: '10px',
		},
		polygon: {
			fill: theme.palette.common.black,
			stroke: theme.palette.divider,
			strokeWidth: 1,
		},
		printArea: {
			alignItems: 'center',
			display: 'flex',
			justifyContent: 'flex-end',
		},
		printBtn: {
			marginRight: '15px',
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(1),
		},
		skillTitle: {
			marginLeft: '15px',
		},
		svgBase: {
			fillOpacity: 0,
			height: '100%',
		},
		svgGBase: {
			'&>circle': {
				'&:hover': {
					r: '6px',
				},
			},
			'&>line': {
				'&:hover': {
					strokeWidth: '3px !important',
				},
			},
			transform: 'scale(1)',
		},
		table: {
			backgroundColor: '#FFF',
		},
		tableCell: {
			cursor: 'default',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		tableCol: {
			borderBottom: `1px solid ${grey[400]}`,
			borderRight: `1px solid ${grey[400]}`,
			display: 'flex',
			height: '52px',
			minWidth: '20px',
			padding: '14px 16px 14px 16px',
			width: '100%',
		},
		tableHeaderCol: {
			backgroundColor: grey[300],
			borderTop: `1px solid ${grey[400]}`,
			color: theme.palette.common.black,
			fontSize: 16,
			minWidth: '20px',
		},
		tableRateCell: {
			cursor: 'default',
			minWidth: '20px',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		tableRow: {
			display: 'flex',
			flexDirection: 'row',
		},
	});

/**
 * チャート
 */
export enum ChartTypeEnum {
	Bar,
	Line,
}

/**
 * チャート情報
 */
export interface IChartInfo {
	key: string;
	name: string;
	type: ChartTypeEnum;
	color: string;
	width: number;
	height: number;
	radius: number;
}

/**
 * 表情報
 */
export interface ITableInfo {
	key: string;
	align: 'left' | 'right' | 'inherit' | 'center' | 'justify' | undefined;
	name: string;
	headerAlign:
		| 'left'
		| 'right'
		| 'inherit'
		| 'center'
		| 'justify'
		| undefined;
}

interface IChart {
	arr: string[];
	line: string;
	lineData: ILine[];
	data: IRect[];
	type: ChartTypeEnum;
	color: string;
}

interface IGridChartProps {
	data: any[];
	categoryFlg: number;
	chart: IChartInfo[];
	tableInfo: ITableInfo[];
}

interface IState {
	chartData: IChart[];
	chartDrawData: IChart[];
	gridData: any[];
	open: boolean;
	svgBase: any;
	toolTipInfo: any;
}

interface IRect {
	x: string;
	y: string;
	fill: string;
	radius: number;
	width: string;
	name?: string;
}

interface ILine {
	x1: string;
	x2: string;
	y1: string;
	y2: string;
	fill: string;
}

const polylineStyle = {
	strokeWidth: '2',
};

class GridChart extends React.Component<IProps, IState> {
	protected baseDiv: React.RefObject<HTMLDivElement>;
	public constructor(props: IProps) {
		super(props);

		this.state = {
			chartData: [],
			chartDrawData: [],
			gridData: [...this.props.data],
			open: false,
			svgBase: {
				left: '0px',
				top: '0px',
				width: '0px',
			},
			toolTipInfo: { show: 'none' },
		};

		this.baseDiv = React.createRef();
	}

	public componentDidMount() {
		this.renderSvgChart();
		const type = isMobile() ? 'orientationchange' : 'resize';
		window.addEventListener(type, this.resizeWrapper);
	}

	public componentWillUnmount() {
		const type = isMobile() ? 'orientationchange' : 'resize';
		window.removeEventListener(type, this.resizeWrapper);
	}

	public componentWillReceiveProps(nextProps: any) {
		if (nextProps.tableInfo) {
			this.setState(
				{
					gridData: nextProps.data,
				},
				() => {
					this.renderSvgChart();
				}
			);
		}
	}

	public render() {
		const { classes } = this.props;
		return (
			<div>
				<Popover
					anchorReference="anchorPosition"
					anchorPosition={{ top: 0, left: 0 }}
					anchorOrigin={{
						horizontal: 'left',
						vertical: 'top',
					}}
					transformOrigin={{
						horizontal: 'right',
						vertical: 'top',
					}}
					open={this.state.open}
				>
					The content of the Popover.
				</Popover>
				<div
					className={classes.table}
					style={{ display: 'flex', marginTop: '10px' }}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							width: '50%',
						}}
					>
						<div
							className={`${classes.tableHeaderCol}`}
							style={{
								borderLeft: `1px solid ${grey[400]}`,
								display: 'flex',
								width: '100%',
							}}
						>
							{this.props.tableInfo.map((info, ci) => {
								if (info.key !== 'chart') {
									return (
										<div
											key={ci}
											className={classes.tableCol}
											style={{
												justifyContent:
													info.headerAlign,
											}}
										>
											<div
												className={classes.tableCell}
												style={{
													wordBreak: 'keep-all',
												}}
											>
												{info.name}
											</div>
										</div>
									);
								} else {
									return <div />;
								}
							})}
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								width: '100%',
							}}
						>
							{this.state.gridData.map((row, ri) => {
								return (
									<StyledGridRow
										key={ri}
										style={{ display: 'flex' }}
									>
										{this.props.tableInfo.map((col, ci) => {
											if (ci === 0) {
												return (
													<div
														style={{
															justifyContent:
																col.align,
														}}
														className={
															classes.tableCol
														}
													>
														<div
															className={
																classes.tableCell
															}
														>
															{row[col.key]}
														</div>
													</div>
												);
											} else {
												const rates = [];
												for (
													let i = 0;
													i < Number(row[col.key]);
													i++
												) {
													rates.push(i);
												}
												if (col.key === 'count') {
													if (
														Number(row[col.key]) ===
														-1
													) {
														return (
															<div
																style={{
																	justifyContent:
																		col.align,
																}}
																className={
																	classes.tableCol
																}
															>
																<div
																	className={
																		classes.tableCell
																	}
																>
																	---
																</div>
															</div>
														);
													} else {
														return (
															<div
																style={{
																	justifyContent:
																		col.align,
																}}
																className={
																	classes.tableCol
																}
															>
																<div
																	className={
																		classes.tableRateCell
																	}
																>
																	{rates.map(
																		(
																			icon,
																			ii
																		) => {
																			return (
																				<StarRate
																					key={
																						ii
																					}
																				/>
																			);
																		}
																	)}
																</div>
															</div>
														);
													}
												} else {
													if (col.key === 'chart') {
														return (
															<div
																style={{
																	width:
																		'0px',
																}}
															/>
														);
													} else {
														return (
															<div
																style={{
																	justifyContent:
																		col.align,
																}}
																className={
																	classes.tableCol
																}
															>
																<div
																	className={
																		classes.tableCell
																	}
																>
																	{row[
																		col.key
																	] + '%'}
																</div>
															</div>
														);
													}
												}
											}
										})}
									</StyledGridRow>
								);
							})}
						</div>
					</div>
					<div style={{ width: '50%' }}>
						<div
							style={{
								width: '100%',
							}}
							className={classes.tableHeaderCol}
						>
							<div
								className={classes.tableCol}
								style={{
									justifyContent: 'center',
									width: '100%',
								}}
							>
								{i18n.t('GridChart_0001')}
							</div>
						</div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								position: 'relative',
								width: '100%',
							}}
						>
							<div
								style={{
									display: 'flex',
									height: '100%',
									left: '0px',
									position: 'absolute',
									top: '0px',
									width: '100%',
								}}
							>
								<div style={{ height: '100%', width: '5px' }} />
								<div
									style={{
										height: '100%',
										position: 'relative',
										width: '100%',
									}}
								>
									<div
										style={{
											height: '100%',
											width: '100%',
										}}
										ref={this.baseDiv}
									/>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										xmlnsXlink="http://www.w3.org/1999/xlink"
										version="1.1"
										style={{
											left: '0px',
											position: 'absolute',
											top: '0px',
											width: '100%',
										}}
										className={classes.svgBase}
									>
										{this.state.chartDrawData.map(chart => {
											if (
												chart.type === ChartTypeEnum.Bar
											) {
												return chart.data.map(
													(rect, ri) => {
														return (
															<g
																key={'g' + ri}
																width="100%"
															>
																<rect
																	key={
																		'b' + ri
																	}
																	height="21"
																	width="100%"
																	fillOpacity="0"
																	strokeOpacity="null"
																	stroke="#000"
																	fill={
																		rect.fill
																	}
																	x="0"
																	y={rect.y}
																/>
																<rect
																	key={
																		'f' + ri
																	}
																	height="21"
																	width={
																		rect.x
																	}
																	fillOpacity="1"
																	strokeOpacity="null"
																	stroke={
																		rect.fill
																	}
																	fill={
																		rect.fill
																	}
																	x="0"
																	y={rect.y}
																/>
															</g>
														);
													}
												);
											} else {
												return (
													<g
														width="100%"
														className={
															classes.svgGBase
														}
													>
														{chart.data.map(
															(circle, ri) => {
																return (
																	<circle
																		key={ri}
																		height="5"
																		width="5"
																		fillOpacity="1"
																		strokeOpacity="null"
																		// tslint:disable-next-line:jsx-no-lambda
																		onMouseEnter={() =>
																			this.handlePopoverOpen(
																				circle
																			)
																		}
																		// tslint:disable-next-line:jsx-no-lambda
																		onMouseLeave={() =>
																			this.handlePopoverClose(
																				circle
																			)
																		}
																		stroke={
																			circle.fill
																		}
																		fill={
																			circle.fill
																		}
																		r={
																			circle.radius
																		}
																		cx={
																			circle.x
																		}
																		cy={
																			circle.y
																		}
																	/>
																);
															}
														)}
														{chart.lineData.map(
															(rect, ri) => {
																return (
																	<line
																		key={ri}
																		style={
																			polylineStyle
																		}
																		stroke={
																			chart.color
																		}
																		x1={
																			rect.x1
																		}
																		x2={
																			rect.x2
																		}
																		y1={
																			rect.y1
																		}
																		y2={
																			rect.y2
																		}
																		fill={
																			rect.fill
																		}
																	/>
																);
															}
														)}
													</g>
												);
											}
										})}
										<defs>
											<g
												id="chartToolTip"
												width="100%"
												fillOpacity="0.8"
											>
												<polygon
													points={
														this.state.toolTipInfo
															.path
													}
													className={classes.polygon}
													style={{
														display: this.state
															.toolTipInfo
															.triangleShow
															? ''
															: 'none',
													}}
													transform="translate(0, 9)"
												/>
												<rect
													x="15"
													y="0"
													rx="5"
													ry="5"
													width="158"
													height="27"
													stroke-width="1.5"
													stroke="#000"
													fill="#000"
												/>
												<text
													x="18"
													y="18"
													stroke-width="0"
													stroke="#fff"
													fill="#fff"
													fontSize="14"
												>
													{
														this.state.toolTipInfo
															.text
													}
												</text>
												<polygon
													points={
														this.state.toolTipInfo
															.path
													}
													className={classes.polygon}
													style={{
														display: !this.state
															.toolTipInfo
															.triangleShow
															? ''
															: 'none',
													}}
													transform="translate(0, 9)"
												/>
											</g>
										</defs>
										<use
											xlinkHref="#chartToolTip"
											x={this.state.toolTipInfo.x}
											y={this.state.toolTipInfo.y}
											style={{
												display: this.state.toolTipInfo
													.show,
											}}
										/>
									</svg>
								</div>
								<div style={{ height: '100%', width: '5px' }} />
							</div>
							{this.state.gridData.map((row, ri) => {
								return (
									<div key={ri} style={{ display: 'flex' }}>
										<div className={classes.tableCol} />
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	}

	protected handlePopoverOpen = (circle: IRect) => {
		// this.setState({ open: true });
		let path = '5,5 15,0, 15,10';
		let x = circle.x;
		let triangleShow = true;
		if (this.baseDiv.current) {
			const offsetWidth = this.baseDiv.current.offsetWidth;
			const rightWidth =
				offsetWidth -
				(offsetWidth * Number(circle.x.replace(/\%/g, ''))) / 100;
			const leftWidth =
				(offsetWidth * Number(circle.x.replace(/\%/g, ''))) / 100;
			if (rightWidth < 180) {
				path = '174,0 184,5, 174,10';
				x = leftWidth - 190 + 'px';
				triangleShow = false;
			}
		}
		this.setState({
			toolTipInfo: {
				path,
				show: true,
				text: circle.name + '：' + circle.x,
				translate: `translate(${x}, ${Number(circle.y) - 14}px)`,
				triangleShow,
				x,
				y: `${Number(circle.y) - 14}`,
			},
		});
	};

	protected handlePopoverClose = (circle: IRect) => {
		// this.setState({ open: false });
		this.setState({
			toolTipInfo: {
				show: 'none',
			},
		});
	};

	protected resizeWrapper = () => {
		this.renderSvgChart();
	};

	private toIRectArray = (arr: string[], fill: string) => {
		const rectArr: IRect[] = [];
		for (const obj of arr) {
			rectArr.push({
				fill,
				radius: 0,
				width: '',
				x: obj.split(',')[0],
				y: obj.split(',')[1],
			});
		}

		return rectArr;
	};

	private calcSvgChart2 = (
		arr: IRect[],
		height: number,
		width: number,
		radius: number,
		type: ChartTypeEnum,
		name: string
	) => {
		const rectArr: IRect[] = [];
		if (type === ChartTypeEnum.Bar) {
			for (const obj of arr) {
				rectArr.push({
					fill: obj.fill,
					radius: 0,
					width: width + '',
					x: Number(obj.x).toFixed(1) + '%',
					y: Number(obj.y) - (height - 1) / 2 + '',
				});
			}
		} else if (type === ChartTypeEnum.Line) {
			for (const obj of arr) {
				rectArr.push({
					fill: obj.fill,
					name,
					radius,
					width: '0px',
					x: Number(obj.x).toFixed(1) + '%',
					y: Number(obj.y) + '',
				});
			}
		} else {
			return arr;
		}

		return rectArr;
	};

	private renderSvgChart = () => {
		if (this.baseDiv.current) {
			if (this.state.gridData.length > 0 && this.props.chart.length > 0) {
				const offsetTop = 0;
				const offsetWidth = this.baseDiv.current.offsetWidth;
				const rowHeight = 52;
				const charts: IChart[] = [];
				for (const chartInfo of this.props.chart) {
					const key = chartInfo.key;
					let path = offsetTop + 26;
					const chartData: IChart = {
						arr: [],
						color: '#000000',
						data: [],
						line: '',
						lineData: [],
						type: ChartTypeEnum.Line,
					};
					const arr: string[] = [];
					path = offsetTop + Math.floor(rowHeight / 2);
					this.state.gridData.map((row, ri) => {
						const rowOffset = 52;
						arr.push(Number(row[key]) + ',' + path);
						path = path + rowOffset;
					});

					chartData.arr = arr;
					chartData.line = arr.join(' ');
					chartData.data = this.calcSvgChart2(
						this.toIRectArray(arr, chartInfo.color),
						chartInfo.height,
						chartInfo.type === ChartTypeEnum.Bar
							? offsetWidth - 10
							: chartInfo.width - 10,
						chartInfo.radius,
						chartInfo.type,
						chartInfo.name
					);
					chartData.type = chartInfo.type;
					chartData.color = chartInfo.color;
					chartData.lineData = [];
					if (this.props.categoryFlg === 1) {
						for (let i = 0; i < chartData.data.length - 1; i++) {
							chartData.lineData.push({
								fill: chartData.data[i].fill,
								x1: chartData.data[i].x,
								x2: chartData.data[i + 1].x,
								y1: chartData.data[i].y,
								y2: chartData.data[i + 1].y,
							});
						}
					}

					charts.push(chartData);
				}

				this.setState(() => ({
					chartDrawData: charts,
				}));
			}
		}
	};
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IGridChartProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(GridChart);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/GridChart.tsx